import axios from 'axios'
import config from '@/config'

// When the project frontend is complete, these calls will be unnecessaries.
const requestRPCPlatform = async (methodName: any, params: any) => {
  const rpcEndpoint = 'bmp.rpc'
  const messageBody = {
    'object': 'API',
    'method': methodName,
    'params': params
  }
  const configUrl = {
    headers: { 'Content-Type': 'text/plain' },
    withCredentials: true
  }
  // Remove the termination from the url
  // apiPlatformUrl = https://{stage}.bluemessaging.net/rest/v0/
  let url = config.apiPlatformUrl.slice(0, -8)
  url = `${url}${rpcEndpoint}`
  const response = await axios.post(url, messageBody, configUrl)
  return response.data
}

export default requestRPCPlatform
